import React, { Fragment, useState } from 'react';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { withTranslation } from 'react-i18next';
import { FreeMode } from 'swiper';

const OfferCategoriesBannerComponent = (props) => {
  const { image, title, offerCategories, categoryDetails } = props?.fields;

  const { params, i18n } = props;
  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderTitle = !!title?.value;
  const shouldRenderOfferCategories = Array.isArray(offerCategories) && offerCategories.length > 0;

  const [isHovered, setIsHovered] = useState(false);
  let language = i18n.language;
  const filterOfferCategories = (offerCategories, categoryDetails) => {
    let categories = offerCategories
      ?.map((offerCategory) => {
        const offerCategoryId = offerCategory?.fields?.offerCategory?.id?.toString()?.toLowerCase();
        const categoryPassed = categoryDetails?.find(
          (categoryDetail) =>
            categoryDetail?.categoryId?.toString()?.toLowerCase() === offerCategoryId &&
            categoryDetail?.count >= 1
        );
        return categoryPassed ? offerCategory : false;
      })
      .filter((item) => {
        return item;
      });

    return categories;
  };

  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="OfferCategoriesBannerComponent" />;
  }
  return (
    <div className={clsx('OfferCategoriesBannerComponent', 'add-margins', params?.Styles)}>
      {shouldRenderImage && (
        <figure>
          <Image field={image} />
        </figure>
      )}

      <div className="wrap content">
        {shouldRenderTitle && (
          <div className="title">
            <Text field={title} />
          </div>
        )}

        {shouldRenderOfferCategories && (
          <Swiper
            modules={[FreeMode]}
            dir={language === 'en' ? 'ltr' : 'rtl'}
            slidesPerView={'auto'}
            direction={'horizontal'}
            freeMode={true}
            spaceBetween={0}
          >
            <SwiperSlide className="listing flex-it flex-wrap">
              {filterOfferCategories(offerCategories, categoryDetails).map(
                (offerCategory, index) => {
                  return (
                    <Fragment key={index}>
                      <a
                        href={offerCategory?.url}
                        className={clsx('item', `${offerCategory.id}`)}
                        onMouseEnter={() => {
                          setIsHovered(true);
                        }}
                        onMouseLeave={() => {
                          setIsHovered(false);
                        }}
                      >
                        <div className="icon">
                          <Image className="normalIcon" field={offerCategory?.fields?.icon} />
                          <Image className="hoverIcon" field={offerCategory?.fields?.hoverIcon} />
                        </div>
                        <div className="text flex-it flex-align-item-start">
                          <RichText
                            className="l-text-wrap"
                            field={offerCategory?.fields?.pageTitle}
                          />
                          <img
                            src={`/-/jssmedia/Project/FAB2/shared/images/offersArrowRight.svg`}
                            alt=""
                            className="arrow"
                          />
                          <img
                            src={`/-/jssmedia/Project/FAB2/shared/images/backArrowWhite.svg`}
                            alt=""
                            className="arrow alternative"
                          />
                        </div>
                      </a>
                      {index + 1 !== 0 && (index + 1) % 4 === 0 && (
                        <div className="seperator"></div>
                      )}
                    </Fragment>
                  );
                }
              )}
            </SwiperSlide>
          </Swiper>
        )}
      </div>
    </div>
  );
};
export default withTranslation()(OfferCategoriesBannerComponent);
